module.exports = __webpack_public_path__ + "img/pep-smart-plug.48d8724f.png";